export function urlEncode(state) {
    return encodeURIComponent(btoa(JSON.stringify(state)));
}
export function urlDecode(encoded) {
    return JSON.parse(atob(decodeURIComponent(encoded)));
}
// function btoa(data: string): string {
//   return Buffer.from(data).toString("base64");
// }
// function atob(data: string): string {
//   return Buffer.from(data, "base64").toString("ascii");
// }
